function isNameValid(input: string | null | undefined): boolean {
  if (input == null) {
    return false;
  }

  if (input.trim().length === 0) {
    return false;
  }

  const allowedSymbols = [
    'а',
    'б',
    'в',
    'г',
    'д',
    'е',
    'ё',
    'ж',
    'з',
    'и',
    'й',
    'к',
    'л',
    'м',
    'н',
    'о',
    'п',
    'р',
    'с',
    'т',
    'у',
    'ф',
    'х',
    'ц',
    'ч',
    'ш',
    'щ',
    'ъ',
    'ы',
    'ь',
    'э',
    'ю',
    'я',
    '-',
    ' ',
  ];

  for (let i = 0; i < input.length; i++) {
    const letter = input[i].toLowerCase();

    if (!allowedSymbols.includes(letter)) {
      return false;
    }
  }

  return true;
}

export default isNameValid;
